import { asUserId } from "@goodfill/domain-properties";
import { z } from "zod";
import { Fetcher } from "../../fetcher";
import { asCognitoIdToken, asRefreshToken } from "./authTypes";

const signInErrorCodes = [
  z.literal("notAuthorized"),
  z.literal("userNotConfirmed"),
  z.literal("userNotFound"),
] as const;

const signInAuthResultSchema = z.object({
  ChallengeParameters: z.object({}),
  AuthenticationResult: z.object({
    AccessToken: z.string(),
    ExpiresIn: z.number(),
    TokenType: z.literal("Bearer"),
    RefreshToken: z.string().transform(asRefreshToken),
    IdToken: z.string().transform(asCognitoIdToken),
  }),
});

const schema = z.object({
  auth: signInAuthResultSchema,
  groups: z.array(z.string()),
  userData: z.object({
    Username: z.string().transform(asUserId),
    UserAttributes: z.array(z.object({ Name: z.string(), Value: z.string() })),
  }),
});

export type ApiSignInOkResponse = z.infer<typeof schema>;
export type ApiSignInRequest = { username: string; password: string };

export const signIn = async (fetcher: Fetcher, request: ApiSignInRequest) => {
  return fetcher({
    endpoint: "/users/signIn",
    method: "POST",
    data: request,
    schema: schema,
    errors: signInErrorCodes,
  });
};
